document.addEventListener('DOMContentLoaded', () => {
  const mobileMedia = window.matchMedia('(max-width: 749px)');

  function deepMerge(target, ...sources) {
    sources.forEach((source) => {
      Object.keys(source ?? {}).forEach((key) => {
        const sourceValue = source[key];
        const targetValue = target[key];

        if (
          sourceValue &&
          typeof sourceValue === 'object' &&
          !Array.isArray(sourceValue) &&
          !(typeof Element !== 'undefined' && sourceValue instanceof Element)
        ) {
          target[key] = deepMerge(
            targetValue && typeof targetValue === 'object' && !Array.isArray(targetValue) ? targetValue : {},
            sourceValue
          );
        } else {
          target[key] = sourceValue;
        }
      });
    });

    return target;
  }

  function slideToggle(element) {
    if (!element) return;

    const isHidden = window.getComputedStyle(element).display === 'none';

    element.style.overflow = 'hidden';
    element.style.transition = 'height 250ms ease';

    if (isHidden) {
      element.style.display = 'block';
      element.style.height = '0px';
      void element.offsetHeight;
      element.style.height = `${element.scrollHeight}px`;

      setTimeout(() => {
        element.style.height = '';
        element.style.overflow = '';
        element.style.transition = '';
      }, 260);
    } else {
      element.style.height = `${element.scrollHeight}px`;
      void element.offsetHeight;
      element.style.height = '0px';

      setTimeout(() => {
        element.style.display = 'none';
        element.style.height = '';
        element.style.overflow = '';
        element.style.transition = '';
      }, 260);
    }
  }

  document.querySelectorAll('.tab').forEach((tab) => {
    tab.addEventListener('click', (evt) => {
      const targetSelector = tab.getAttribute('data-toggle-target');

      evt.preventDefault();
      tab.classList.add('active');

      Array.from(tab.parentElement?.children ?? []).forEach((sibling) => {
        if (sibling !== tab && sibling.classList) sibling.classList.remove('active');
      });

      document.querySelectorAll('.tab-content').forEach((content) => {
        content.classList.remove('active');
      });

      if (targetSelector) {
        document.querySelectorAll(targetSelector).forEach((content) => {
          content.classList.add('active');
        });
      }
    });
  });

  setTimeout(() => {
    const installment = document.querySelector('.installment');
    const zenrushContainer = document.querySelector('.zenrush-container');

    if (installment && zenrushContainer) zenrushContainer.appendChild(installment);

    document.querySelectorAll('.back-stock-trigger').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        slideToggle(document.querySelector('.bis-form-wrap'));
      });
    });
  }, 500);

  function getDirectChild(parent, selector) {
    return Array.from(parent.children).find((child) => child.matches(selector));
  }

  function prepareSwiperElement(slider) {
    if (!slider || slider.dataset.swiperReady === 'true') return false;

    if (slider.matches('ul, ol')) {
      const listContainer = document.createElement('div');
      listContainer.className = 'swiper';
      slider.parentNode.insertBefore(listContainer, slider);
      listContainer.appendChild(slider);

      slider.classList.add('swiper-wrapper');
      Array.from(slider.children).forEach((child) => {
        child.classList.add('swiper-slide');
      });

      slider.dataset.swiperReady = 'true';
      return listContainer;
    }

    slider.classList.add('swiper');

    let wrapper = getDirectChild(slider, '.swiper-wrapper');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'swiper-wrapper';

      Array.from(slider.children).forEach((child) => {
        if (child.matches('.swiper-button-prev, .swiper-button-next, .swiper-pagination, script, style, template')) {
          return;
        }

        child.classList.add('swiper-slide');
        wrapper.appendChild(child);
      });

      slider.appendChild(wrapper);
    } else {
      Array.from(wrapper.children).forEach((child) => {
        child.classList.add('swiper-slide');
      });
    }

    slider.dataset.swiperReady = 'true';
    return slider;
  }

  function addSwiperPagination(slider) {
    let pagination = getDirectChild(slider, '.swiper-pagination');
    if (!pagination) {
      pagination = document.createElement('div');
      pagination.className = 'swiper-pagination';
      slider.appendChild(pagination);
    }

    return pagination;
  }

  function addSwiperNavigation(slider, options) {
    let prev = getDirectChild(slider, '.swiper-button-prev');
    let next = getDirectChild(slider, '.swiper-button-next');

    if (!prev) {
      prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'swiper-buttons swiper-button-prev';
      prev.setAttribute('aria-label', 'Previous slide');
      prev.innerHTML = options?.prevIcon ?? '';
      slider.appendChild(prev);
    }

    if (!next) {
      next = document.createElement('button');
      next.type = 'button';
      next.className = 'swiper-buttons swiper-button-next';
      next.setAttribute('aria-label', 'Next slide');
      next.innerHTML = options?.nextIcon ?? '';
      slider.appendChild(next);
    }

    return { prevEl: prev, nextEl: next };
  }

  function initSwiper(selector, settings) {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll(selector).forEach((slider) => {
      if (settings?.condition && !settings.condition()) return;

      const swiperElement = prepareSwiperElement(slider);
      if (!swiperElement) return;

      const options = deepMerge({}, settings?.options ?? {});

      if (settings?.pagination) {
        options.pagination = deepMerge(
          { el: addSwiperPagination(swiperElement), clickable: true },
          options.pagination ?? {}
        );
      }

      const navigationEnabled =
        typeof settings?.navigation === 'function'
          ? settings.navigation(swiperElement)
          : Boolean(settings?.navigation);

      if (navigationEnabled) {
        const navOptions = typeof settings.navigation === 'object' ? settings.navigation : {};
        options.navigation = deepMerge(
          addSwiperNavigation(swiperElement, navOptions),
          options.navigation ?? {}
        );
      }

      new Swiper(swiperElement, options);
    });
  }

  initSwiper('.vertical-thumbnail-slider', {
    navigation: (swiperEl) => swiperEl.querySelectorAll('.swiper-slide').length > 4,
    options: {
      slidesPerView: 'auto',
      spaceBetween: 10,
      watchSlidesProgress: true,
      autoHeight: true,
      on: {
        init() {
          const parent = this.el?.parentNode;
          if (!parent) return;

          const prev = this.el.querySelector('.swiper-button-prev');
          const next = this.el.querySelector('.swiper-button-next');

          if (prev) parent.appendChild(prev);
          if (next) parent.appendChild(next);

          const swiper = this;

          function syncThumbByMediaId(mediaId) {
            if (!mediaId) return;
            const slides = Array.from(swiper.slides || []);
            const activeIndex = slides.findIndex((slide) => slide.dataset.target === mediaId);
            if (activeIndex < 0) return;
            slides.forEach((slide, i) => {
              slide.classList.toggle('swiper-slide-thumb-active', i === activeIndex);
            });
            swiper.slideTo(activeIndex, 300, false);
          }

          // Initial sync from is-active class (set on page load / variant change)
          const initialActive = document.querySelector('.product__media-item.is-active');
          syncThumbByMediaId(initialActive?.dataset?.mediaId);

          // Sync when main gallery is swiped (slideChanged fires; is-active does NOT change)
          const viewer = document.querySelector('[id^="GalleryViewer"]');
          if (viewer) {
            viewer.addEventListener('slideChanged', (event) => {
              syncThumbByMediaId(event.detail?.currentElement?.dataset?.mediaId);
            });
          }

          // Sync when a thumbnail click changes is-active (setActiveMedia path)
          const mediaList = document.querySelector('.product__media-list');
          if (mediaList) {
            new MutationObserver(() => {
              const activeItem = mediaList.querySelector('.product__media-item.is-active');
              syncThumbByMediaId(activeItem?.dataset?.mediaId);
            }).observe(mediaList, { subtree: true, attributes: true, attributeFilter: ['class'] });
          }
        }
      },
      breakpoints: {
        750: {
          direction: 'vertical',
          slidesPerView: 5
        }
      }
    }
  });

  const mbTextIconEl = document.querySelector('.text-with-icons-slider[data-mobile-column]');

  initSwiper('.text-with-icons-slider', {
    condition: () => mobileMedia.matches,
    options: {
      loop: true,
      slidesPerView: mbTextIconEl ? parseFloat(mbTextIconEl.dataset.mobileColumn) : 1,
      slidesPerGroup: 1,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    }
  });

  initSwiper('.orthogo-testimonial-cards', {
    options: {
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation:
        document.querySelectorAll('.orthogo-testimonial-cards .swiper-button-next')
          .length &&
          document.querySelectorAll('.orthogo-testimonial-cards .swiper-button-prev')
            .length
          ? {
            nextEl: '.orthogo-testimonial-cards .swiper-button-next',
            prevEl: '.orthogo-testimonial-cards .swiper-button-prev',
          }
          : false,

      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        600: {
          slidesPerView: 1,
        },
        800: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    },
  });

  initSwiper('.gallery-container-main', {
    options: {
      loop: true,
      freeMode: true,
      grabCursor: true,
      speed: 3000,
      freeModeMomentum: false,
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      breakpoints: {
        300: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 2.5,
          spaceBetween: 30,
        },
      },

      on: {
        init: function () {
          const swiper = this;
          const gallery = swiper.el;

          gallery.addEventListener('mouseenter', function () {
            swiper.autoplay.stop();
          });

          gallery.addEventListener('mouseleave', function () {
            swiper.autoplay.start();
          });
        }
      }
    }
  });

  initSwiper('.custom-slider-image-text', {
    navigation: true,
    pagination: true,
    options: {
      autoplay: false,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 20,
      on: {
        init() {
          const parent = this.el?.parentNode;
          if (!parent) return;

          const prev = this.el.querySelector('.swiper-button-prev');
          const next = this.el.querySelector('.swiper-button-next');

          if (prev) parent.appendChild(prev);
          if (next) parent.appendChild(next);
        }
      }
    }
  });

  const mbProductsEl = document.querySelector('.mb-additional-products[data-mobile-column]');

  initSwiper('.mb-additional-products', {
    condition: () => mobileMedia.matches,
    pagination: true,
    options: {
      slidesPerView: mbProductsEl ? parseFloat(mbProductsEl.dataset.mobileColumn) : 1,
      slidesPerGroup: 1,
      spaceBetween: 10
    }
  });

  setTimeout(() => {
    initSwiper('.bundles-slider', {
      navigation: {
        prevIcon: '<i class="fa-regular fa-chevron-left"></i>',
        nextIcon: '<i class="fa-regular fa-chevron-right"></i>'
      },
      pagination: true,
      options: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        breakpoints: {
          850: {
            slidesPerView: 3
          }
        }
      }
    });
  }, 1000);

  initSwiper('.logo-col-dt-slider', {
    pagination: true,
    options: {
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      speed: 2000,
      freeMode: {
        enabled: true,
        momentum: false
      },
      autoplay: {
        delay: 0,
        disableOnInteraction: false
      },
      breakpoints: {
        850: {
          centeredSlides: false,
          slidesPerView: 3,
          speed: 300,
          freeMode: {
            enabled: false
          },
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          }
        }
      }
    }
  });

  const uspEl = document.querySelector('.om-usp-track');
  const uspOptions = {
    loop: true,
    slidesPerView: 1,
    slidesPerGroup: 1
  };
  if (uspEl?.hasAttribute('data-autoplay')) {
    uspOptions.autoplay = {
      delay: Number(uspEl.dataset.interval) || 3000,
      disableOnInteraction: false
    };
  }
  initSwiper('.om-usp-track', {
    navigation: false,
    condition: () => mobileMedia.matches,
    options: uspOptions
  });

  initSwiper('.iwts-marquee', {
    options: {
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      speed: 8000,
      freeMode: {
        enabled: true,
        momentum: false
      },
      autoplay: {
        delay: 1000,
        disableOnInteraction: false
      }
    }
  });

  initSwiper('.mb-slider-content', {
    condition: () => mobileMedia.matches,
    options: {
      loop: true,
      slidesPerView: 1.2,
      slidesPerGroup: 1,
      spaceBetween: 10
    }
  });

  initSwiper('.logo-row .logo-col', {
    condition: () => mobileMedia.matches,
    pagination: true,
    options: {
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      speed: 2000,
      freeMode: {
        enabled: true,
        momentum: false
      },
      autoplay: {
        delay: 1000,
        disableOnInteraction: false
      }
    }
  });

  initSwiper('.additional-products-slider', {
    pagination: true,
    options: {
      loop: true,
      slidesPerView: 1.2,
      slidesPerGroup: 1,
      spaceBetween: 0,
      breakpoints: {
        850: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: 4
        }
      }
    }
  });

  initSwiper('.image-slider', {
    pagination: true,
    options: {
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      slidesPerView: 1,
      slidesPerGroup: 1,
      navigation: {
        prevEl: '.pp2',
        nextEl: '.nn2'
      }
    }
  });

  initSwiper('.testimonial-row', {
    options: {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      breakpoints: {
        600: {
          slidesPerView: 2,
          slidesPerGroup: 2
        },
        992: {
          slidesPerView: 3,
          slidesPerGroup: 3
        },
        1025: {
          slidesPerView: 4,
          slidesPerGroup: 1
        }
      }
    }
  });

  function getLightboxItems(trigger) {
    const group = trigger.getAttribute('data-lightbox');
    if (!group) return [trigger];

    return Array.from(document.querySelectorAll(`[data-lightbox="${group}"]`)).filter(
      (item) => item.getAttribute('data-modal-src') || item.getAttribute('href')
    );
  }

  function getLightboxSource(item) {
    return item.getAttribute('data-modal-src') || item.getAttribute('href');
  }

  function getVideoEmbedUrl(url) {
    const youtubeMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&?/]+)/);
    const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);

    if (youtubeMatch) return `https://www.youtube.com/embed/${youtubeMatch[1]}?autoplay=1`;
    if (vimeoMatch) return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1`;

    return url;
  }

  function renderLightboxContent(dialog, item) {
    const src = getLightboxSource(item);
    const body = dialog.querySelector('.native-lightbox__body');

    body.innerHTML = '';

    if (src && src.charAt(0) === '#') {
      const inlineContent = document.querySelector(src);
      if (inlineContent) {
        const inlineWrap = document.createElement('div');
        inlineWrap.className = 'native-lightbox__inline';
        inlineWrap.innerHTML = inlineContent.innerHTML;
        body.appendChild(inlineWrap);
      }
      return;
    }

    if (src && src.match(/\.(mp4|mov|ogv|webm)(\?|#|$)/i)) {
      const video = document.createElement('video');
      video.className = 'native-lightbox__video';
      video.src = src;
      video.controls = true;
      video.autoplay = true;
      body.appendChild(video);
      return;
    }

    if (src && src.match(/(youtube\.com|youtu\.be|vimeo\.com)/i)) {
      const iframe = document.createElement('iframe');
      iframe.className = 'native-lightbox__iframe';
      iframe.src = getVideoEmbedUrl(src);
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.setAttribute('allowfullscreen', 'allowfullscreen');
      body.appendChild(iframe);
      return;
    }

    const image = document.createElement('img');
    const sourceImage = item.querySelector('img');
    image.className = 'native-lightbox__image';
    image.src = src;
    image.alt = sourceImage?.getAttribute('alt') ?? '';
    body.appendChild(image);
  }

  let lightboxController = null;

  function openNativeLightbox(trigger) {
    const items = getLightboxItems(trigger);
    let currentIndex = Math.max(items.indexOf(trigger), 0);
    let dialog = document.querySelector('.native-lightbox');

    if (!dialog) {
      dialog = document.createElement('div');
      dialog.className = 'native-lightbox';
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      dialog.innerHTML =
        '<div class="native-lightbox__backdrop" data-lightbox-close></div>' +
        '<div class="native-lightbox__dialog" role="document">' +
        '<button type="button" class="native-lightbox__close" data-lightbox-close aria-label="Close">&times;</button>' +
        '<button type="button" class="native-lightbox__nav native-lightbox__nav--prev" data-lightbox-prev aria-label="Previous">&#8249;</button>' +
        '<div class="native-lightbox__body"></div>' +
        '<button type="button" class="native-lightbox__nav native-lightbox__nav--next" data-lightbox-next aria-label="Next">&#8250;</button>' +
        '</div>';
      document.body.appendChild(dialog);
    }

    function showItem(index) {
      currentIndex = (index + items.length) % items.length;
      renderLightboxContent(dialog, items[currentIndex]);
      dialog.querySelectorAll('.native-lightbox__nav').forEach((button) => {
        button.hidden = items.length < 2;
      });
    }

    function closeLightbox() {
      dialog.classList.remove('is-open');
      dialog.querySelector('.native-lightbox__body').innerHTML = '';
      document.body.classList.remove('native-lightbox-open');
      lightboxController?.abort();
    }

    function handleKeydown(event) {
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft' && items.length > 1) showItem(currentIndex - 1);
      if (event.key === 'ArrowRight' && items.length > 1) showItem(currentIndex + 1);
    }

    lightboxController?.abort();
    lightboxController = new AbortController();
    const { signal } = lightboxController;

    dialog.addEventListener(
      'click',
      (event) => {
        if (event.target.closest('[data-lightbox-close]')) closeLightbox();
        if (event.target.closest('[data-lightbox-prev]')) showItem(currentIndex - 1);
        if (event.target.closest('[data-lightbox-next]')) showItem(currentIndex + 1);
      },
      { signal }
    );

    document.addEventListener('keydown', handleKeydown, { signal });

    showItem(currentIndex);
    dialog.classList.add('is-open');
    document.body.classList.add('native-lightbox-open');
    dialog.querySelector('.native-lightbox__close').focus();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-lightbox], [data-modal-src]');
    if (!trigger) return;

    event.preventDefault();
    openNativeLightbox(trigger);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const trigger = event.target.closest('[data-lightbox], [data-modal-src]');
    if (!trigger) return;

    event.preventDefault();
    openNativeLightbox(trigger);
  });

  function initTableOfContents() {
    const toc = document.querySelector('#toc');
    const content = document.querySelector('div.article-content');
    if (!toc || !content) return;

    const headings = Array.from(content.querySelectorAll('h2'));
    if (!headings.length) return;

    const list = document.createElement('ul');

    headings.forEach((heading, index) => {
      if (!heading.id) {
        heading.id =
          `toc-heading-${index}-` +
          heading.textContent
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-|-$/g, '');
      }

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      item.appendChild(link);
      list.appendChild(item);
    });

    toc.innerHTML = '';
    toc.appendChild(list);
  }

  initTableOfContents();
});